import { BsPaperclip } from "react-icons/bs";
import Banner from "../../components/Banner";
import Card from "../../components/Card";
import Header from "../../components/Header";
import { getPublic } from "../../lib/helpers";
import styles from "./styles";
import "./styles.css";
import { FcTimeline} from "react-icons/fc"
const ZOOM = "240px"
export default function SheharyarShahid() {

    return (<div style={{ overflow: "hidden" }}>
        <Header>
            <BsPaperclip size="30px" color="var(--git-black)" opacity={0.75} />

            <h2>Portfolio</h2>
        </Header>
        <div style={{ overflowY: 'auto', maxHeight: "100vh", paddingTop: "60px" }} >
            <Banner>
                <div style={{ display: "flex", border: "0px solid green", alignItems: "center" }}>
                    <img style={{ ...styles.image }} alt="Sheharyar Shahid" height={ZOOM} width={ZOOM} src={getPublic("sheharyar.shahid2.png")} />
                </div>
                <span className="main"  >
                    <h1 className="heading" style={{ whiteSpace: "nowrap" }} >Sheharyar Shahid</h1>
                    <div className="description"> Shahid is a distinguished senior software engineer who has worked on software technologies like Dockers, AWS, React, React Native, Node.js, C# .NET 5, and much more. His career expands over three years, during which his decision-making and leadership have helped his company earn contracts worth millions of dollars from a NASDAQ-listed client. Shahid is presently working with a US enterprise client, assisting the team in handling their new SDKs.</div>
                </span>
            </Banner>

            <div style={{ display: "flex", position: "relative", width: "100%", flexDirection: "row", alignItems: "flex-end", marginTop: 40, justifyContent: "center", marginBottom: -1, }} >
                {/* <div style={{flex:1,display:"flex",backgroundColor:"rgb(134,134,135)",height:"0.8px"}} /> */}
                
                <div  style={{ fontSize: "1.5em",
                               whiteSpace: "nowrap", 
                               paddingLeft: 14, 
                               paddingRight: 14, 
                               color: "var(--git-black-near)", 
                               verticalAlign: "top", 
                               backgroundColor: "rgb(234,234,235)", 
                               lineHeight: 1.8, 
                               borderTopRightRadius: 4, 
                               borderTopLeftRadius: 4, 
                               border: "0px solid rgb(134,134,135)", 
                               borderBottomWidth: 0,
                               position:"relative"
                               
                               }}>
                                <div  style={{ boxShadow:"0  0px 20px  0px var(--git-black-half)",position:"absolute",left:0,right:0,width:"auto",height:"100%",zIndex:-1,      borderTopRightRadius: 4, 
                               borderTopLeftRadius: 4, }}></div>
                    <FcTimeline style={{marginBottom:-3,marginRight:4}} /> Timeline
                </div>
              
                {/* <div style={{flex:1,display:"flex",backgroundColor:"rgb(134,134,135)",height:"0.8px"}} /> */}

            </div>
            <div style={{    boxShadow:"0  0px 20px  0px var(--git-black-half)",backgroundColor: "rgb(234,234,235)", paddingBottom: "200px", paddingTop: 40 ,borderWidth:1,
            //border:"1px solid black",
            width:"100vw",
            display:'flex',
            flex:1,
            borderTopWidth:0,
            flexDirection:"column",


            }} >

                {/* <div style={{width:"99vw",backgroundColor:"red",height:10}} /> */}
                <Card />
                <Card/>
                
                {/* <Card/> */}
            </div>
        </div>



    </div>
    )
}  